import React, { useState, useEffect } from 'react';
import Spinner from './Spinner';
import iconminus from '../iconminus.png';
import iconplus from '../iconplus.png';
import { api } from '../apis/configs/axiosConfigs';

// Accordion component to show detailed information
const Accordion = ({ isOpen, data }) => {
    if (!isOpen) return null;

    return (
        <tr style={{border:0}}>
            <td colSpan="5">

                <div class="col-lg-10">
                    {/* Display detailed breakdown of information */}
                    <br />
                    <table class="table table-borderless">
                        <thead>
                            <td></td>
                            <th scope="col">Status</th>
                            <th scope="col">Test</th>
                            <th scope="col">Reason</th>
                        </thead>
                        <tbody>
                            {data.map((rowData, index) => (
                                <tr style={{ color: rowData.checkStatus === false ? "BLACK" : "SILVER" }}>
                                    <td></td>
                                    <td><span style={{ color: rowData.checkStatus === false ? "RED" : "GREEN" }}>{rowData.checkStatus === false ? "FAIL" : "PASS"}</span></td>
                                    <td>{rowData.testTypeName}</td>
                                    <td>{rowData.message}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {/* {data.map((item, index) => (
                <div key={index}>
                    {item.label}: {item.value}
                </div>
            ))} */}
                </div>

            </td>
        </tr>
    );
};

// Row component
const Row = ({ isSelected, rowData, onClick }) => {

    const setIcon = () => {
        return isSelected ? '../assets/iconminus.png' : '../assets/iconplus.png';
    };
    return (
        // <tr onClick={onClick} style={[{ color: "GRAY" },{borderStyle : (isSelected ? 'none' : 'solid')}]}>
        <tr onClick={onClick} style={{borderColor: (isSelected ? 'transparent' : 'inherit')}}>
            <td></td>
            <td>{rowData.serialNumber}</td>
            <td>{rowData.startTimeStamp}</td>
            <td><span style={{ color: rowData.status === "FAIL" ? "RED" : "GREEN" }}>{rowData.status}</span></td>
            {/* <td> <img alt='row-icon' src={setIcon()} >/</img></td> */}
            {/* <td> <img src={isSelected ? '../assets/iconminus.png' : '../assets/iconplus.png'} >/</img></td> */}
            <td> <img height={25} src={isSelected ? iconminus : iconplus} ></img></td>
            {/* Add more columns as needed */}
        </tr>
    );
};

// Table component
const ListResultComponent = ({ startDate, endDate, serialNumber }) => {
    const [data, setData] = useState([]);
    const [activeRow, setActiveRow] = useState(null);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageCount, setPageCount] = useState(50);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);

    // useEffect(() => {
    //     TestingResultAPI(startDate, endDate, serialNumber,currentPage,currentPageCount).then((res) => {
    //         // response handling
    //         console.log(res);

    //         // setData(records);
    //         // setTotalPages(totalPages);
    //         // setTotalRecords(totalRecords);

    //         setLoading(false);
    //     })
    // }, []);

    useEffect(() => {
        fetchData(startDate, endDate, serialNumber, currentPage, currentPageCount);
    }, [currentPage, currentPageCount, startDate, endDate, serialNumber]);

    const fetchData = async (startDate, endDate, serialNumber, currentPage, currentPageCount) => {
        setLoading(true);
        try {
            // Route through the `api` axios instance (baseURL already ends in /api/v1)
            // so the request interceptor attaches XSessionId/XUserId/XUserEmail. The
            // GET /HardwareTest/all endpoint is now [Authorize(XHeaderSession)] on the BFF.
            const params = {};
            if (startDate) params.fromDate = startDate;
            if (endDate) params.toDate = endDate;
            if (serialNumber) params.serialNumber = serialNumber;
            if (currentPage) params.pageNumber = currentPage;
            if (currentPageCount) params.pageSize = currentPageCount;

            const response = await api.get('/HardwareTest/all', { params });

            const { data, totalPages, totalRecords } = response.data;

            if (data.length > 0) {
                for (let index = 0; index < data.length; index++) {
                    const element = data[index];
                    const failedTests = element.results.filter(result => result.checkStatus === false);
                    data[index].status = failedTests.length > 0 ? 'FAIL' : 'PASS';
                }

                // if(data.length < 10){
                //    var count = data.length;
                //     for (let index = count; index < 10; index++) {
                //         data.push(data[0]);
                //     }
                // }

                console.log(data);
                setData(data);
                // setTotalPages(5);
                // setTotalRecords(45);
                setTotalPages(totalPages);
                setTotalRecords(totalRecords);
            }
            else {
                setData(data);
                // setTotalPages(5);
                // setTotalRecords(45);
                setTotalPages(totalPages);
                setTotalRecords(totalRecords);
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleRowClick = (index) => {
        setActiveRow(activeRow === index ? null : index);
    };

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    let listContent;

    if (loading) {
        listContent = <div className="list-msg"><Spinner /></div>;
    }
    else if (data.length === 0) {
        listContent = <div className="list-msg">ℹ️ No Records Found.<br /><br /></div>;
    }
    else {
        // listContent = books.map((book, k) =>
        //     <BookCard book={book} key={k} />
        // );
    }

    return (
        <div>
            <div className="Search">
                <div class="container">
                    <br />
                    <div class="row">

                        {/* {loading && <div>Loading...</div>} */}

                        {listContent}

                        <table class="table">
                            <thead>
                                <tr style={{ fontSize: 30 + 'px' }}>
                                    <th scope="col">#</th>
                                    <th scope="col">Serial Number</th>
                                    <th scope="col">Date</th>
                                    <th scope="col">Status</th>
                                    <th scope="col"></th>
                                    {/* Add more headers as needed */}
                                </tr>
                            </thead>
                            <tbody style={{ color: "GRAY" }}>
                                {data.map((rowData, index) => (
                                    <React.Fragment key={index}>
                                        <Row isSelected={activeRow === index} rowData={rowData} onClick={() => handleRowClick(index)} />
                                        {/* <tr>
                                            <td colSpan="5">
                                            </td>
                                        </tr> */}
                                        {/* Pass isOpen prop based on activeRow state */}
                                        <Accordion isOpen={activeRow === index} data={rowData.results} />
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>

                        {/* Pagination */}
                        <div>
                            <div class="row">
                                <div class="col-lg-3 col-sm-12 col-xs-12">
                                    <div class="d-flex justify-content-center">
                                        <label style={{marginRight:20}}>Records Per Page </label>
                                        <select style={{
                                            textAlign: 'center',
                                            // text-align-last:right;
                                            // textAlign: 'right',
                                            // padding-right: 29px;
                                            // paddingRight: 29,
                                            // direction: rtl;
                                        }} 
                                            class="form control input-xs" value={currentPageCount} onChange={(e) => setPageCount(e.target.value)}>
                                            <option value="10">10</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                            <option value="500">500</option>
                                            <option value="1000">1000</option>
                                            <option value="2000">2000</option>
                                            {/* <option value="10000">10000</option> */}
                                        </select>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-sm-12 col-xs-12">
                                    <div class="d-flex justify-content-center">
                                        <p>Total Records : {totalRecords} </p>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-sm-12 col-xs-12">
                                    <div class="d-flex justify-content-center">

                                        {totalPages > 0 && (
                                            <>

                                                <ul className="pagination">
                                                    {[...Array(totalPages).keys()].map((pageNumber) => (
                                                        <li key={pageNumber + 1} className={`page-item ${currentPage === pageNumber + 1 ? 'active' : ''}`}>
                                                            <button onClick={() => paginate(pageNumber + 1)} className="page-link">
                                                                {pageNumber + 1}
                                                            </button>
                                                        </li>
                                                    ))}
                                                </ul>
                                                
                                                <p><br/><br/>Page : {currentPage} / {totalPages} </p>

                                            </>

                                        )}
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>

    );
};


export default ListResultComponent;